import { strings } from "../../../localization";
import {
	ButtonLayout,
	ButtonPrimary,
	Grid,
	GridItem,
	IconWarningLight,
	Text3,
	skinVars,
	useScreenSize,
} from "@telefonica/mistica";
import React, {useCallback} from "react";
import { FeedbackContainer, ScreenResponsive } from "../../../components";
import { useGlobalStore } from "../../../contexts/globalStoreContext";
import { useNavigateCustom } from "../../../hooks";

const { unavailableFGTS } = strings.components.connectionFeedback.errors;

export const IsOffFGTS: React.FC = () => {
	const navigation = useNavigateCustom();
	const { authenticationStore } = useGlobalStore();
	const { isDesktopOrBigger } = useScreenSize();

	const onLogoutPress = useCallback(() => {
		authenticationStore.logout();
		navigation("/");
	}, []);

	return (
		<ScreenResponsive>
			<Grid justifyContent="center">
				<GridItem>
					<FeedbackContainer
						icon={<IconWarningLight size={64} color={skinVars.colors.controlError} />}
						title={unavailableFGTS.title}
						description={unavailableFGTS.text}
					>
						<ButtonLayout align={isDesktopOrBigger ? "left" : "center"}>
							<ButtonPrimary
								onPress={onLogoutPress}
								showSpinner={false}
								disabled={false}
								style={{ width: isDesktopOrBigger ? "auto" : "100%" }}
							>
								<Text3 medium color={skinVars.colors.textButtonPrimary}>
									{unavailableFGTS.buttons.primaryButton}
								</Text3>
							</ButtonPrimary>
						</ButtonLayout>
					</FeedbackContainer>
				</GridItem>
			</Grid>
		</ScreenResponsive>
	);
};

export default IsOffFGTS;
